import { render, staticRenderFns } from "./CustomToolbar.vue?vue&type=template&id=4151d120&scoped=true"
import script from "./CustomToolbar.vue?vue&type=script&lang=js"
export * from "./CustomToolbar.vue?vue&type=script&lang=js"
import style0 from "./CustomToolbar.vue?vue&type=style&index=0&id=4151d120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151d120",
  null
  
)

export default component.exports